export default __webpack_public_path__ + "static/media/magnifying-glass.feb02ca7.svg";